import axios from "axios";
const tokenVariableName = "admi_token";

const API_URL = process.env.VUE_APP_API_URL;

const apiWithoutToken = axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  });

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem(tokenVariableName);
    if (token) {
      config.headers.d_auth_token = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token) => {
              originalRequest.headers.d_auth_token = 'Bearer ' + token;
              resolve(api(originalRequest));
            },
            reject: (err) => reject(err)
          });
        });
      }
      isRefreshing = true;

      try {
        const newToken = await refreshAccessToken();

        api.defaults.headers.d_auth_token = 'Bearer ' + newToken;

        processQueue(null, newToken);

        originalRequest.headers.d_auth_token = 'Bearer ' + newToken;
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.removeItem(tokenVariableName);
        // window.location.href = '/'; // Or dispatch logout
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

const refreshAccessToken = async () => {
    const response = await api.post(
      "/auth/refresh-token",
      {},
      {
        withCredentials: true,
      }
    );
    if (!response?.data?.accessToken) {
      throw new Error("Failed to refresh token");
    }
    // Store the new access token
    localStorage.setItem(tokenVariableName, response.data.accessToken);

    return response.data.accessToken;
};

export { api, apiWithoutToken };
